import { type TestConfig, type TestFunction } from 'yup';
import { type IMapLayer } from '../MapLayer.ts';

/**
 * Test Yup riutilizzabile che verifica l'univocita' dei `code` dei layer.
 */
export function createUniqueLayerCodesTest(): TestConfig<
  IMapLayer[] | undefined
> {
  const testFn: TestFunction<IMapLayer[] | undefined> = layers => {
    const codes = layers?.map(layer => layer.code).filter(Boolean) ?? [];
    return codes.length === new Set(codes).size;
  };

  return {
    name: 'unique-layer-codes',
    message: 'I codici dei layer devono essere univoci',
    test: testFn,
  };
}

/**
 * Test Yup riutilizzabile che verifica che ci sia al massimo un layer con
 * preset catastale (`intersection.cadastralPreset`).
 */
export function createSingleCadastralPresetTest(): TestConfig<
  IMapLayer[] | undefined
> {
  const testFn: TestFunction<IMapLayer[] | undefined> = layers => {
    const count =
      layers?.filter(layer => layer.intersection?.cadastralPreset).length ?? 0;
    return count <= 1;
  };

  return {
    name: 'single-cadastral-preset',
    message: 'Ci può essere un solo layer catastale',
    test: testFn,
  };
}

/**
 * Test Yup riutilizzabile che verifica l'univocita' degli alias
 * in un oggetto `Record<string, string>`.
 */
export function createUniqueAliasesTest(): TestConfig<
  Record<string, string> | undefined
> {
  const testFn: TestFunction<Record<string, string> | undefined> = aliases => {
    if (!aliases) return true;
    const values = Object.values(aliases).filter(Boolean);
    return values.length === new Set(values).size;
  };

  return {
    name: 'unique-aliases',
    message: 'Gli alias devono essere univoci',
    test: testFn,
  };
}
